import React from 'react';
import styled from 'styled-components';
import { humanizeHoc } from '../../utils';
interface IProps {
  data: string | number;
  column: any;
}

const SourceCell = styled.div`
  padding-left: 7.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const RenderSource = ({ data, column }: IProps) => {
  return (
    <SourceCell>
      <span title={String(data)}>
        {humanizeHoc(data, column.unit)}
      </span>
    </SourceCell>
  )
};

export default React.memo(RenderSource);
